export const FREE_TO_PLAY_ID = 'FreeToPlay'
export const FREE_TO_PLAY_ITEM_CATEGORY = 'FREE_TO_PLAY'
export const FREE_TO_PLAY_ITEM_NAME = 'FreeToPlay'
export const FREE_TO_PLAY_TOP_PRIZE_AMOUNT = 1000000
export const FREE_TO_PLAY_ROUTE = '/mystery-scratch'
